import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce252142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100vw","height":"100vh","color":"red","display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_2 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_svg_icon, {
            name: "ali-loading",
            size: "xl",
            class: "turn"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}